module.exports = __webpack_public_path__ + "static/media/M83ws.7d95e699.pdf";